module.exports = __webpack_public_path__ + "static/media/baebble.ad1b56c8.png";


//////////////////
// WEBPACK FOOTER
// ./public/baebble.png
// module id = 176
// module chunks = 0